module.exports = __webpack_public_path__ + "img/square-font-awesome-stroke.01bdf32e.svg";